<template>
  <div>
    <BaseTitle :title="$t(baseTitlePage)" />

    <template v-if="!isStudentPage">
      <!-- Parent Profile -->
      <v-card class="mb-6">
        <slide-box :value="true">
          <template #activator="{isOpen}">
            <div class="pa-5 d-flex justiy-space-between align-items section-header active">
              <div class="student-title">{{ $t('content.parent_profile') }}</div>
              <v-spacer />
              <v-icon class="app-menu-indicator">{{ isOpen ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
            </div>
          </template>
          <template>
            <Form ref="formParent" type="parent" :initial-data="initialDateParentView" :editable="editable" />
          </template>
        </slide-box>
      </v-card>
    </template>

    <template v-else>
      <!-- Student Profile -->
      <v-card class="mb-6">
        <slide-box :value="true">
          <template #activator="{isOpen}">
            <div class="pa-5 d-flex justiy-space-between align-items section-header active">
              <div class="student-title">{{ $t('content.student_profile') }}</div>
              <v-spacer />
              <v-icon class="app-menu-indicator">{{ isOpen ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
            </div>
          </template>
          <template>
            <Form ref="formStudent" :initial-data="initialDataStudent" :editable="editable" />
          </template>
        </slide-box>
      </v-card>
    </template>

    <!-- student List -->
    <main class="py-5" v-if="isEditParentPage || isViewParentPage">
      <StudentList />
    </main>

    <!-- Controls -->
    <div class="d-flex justify-end align-center">
      <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="back">{{ $t(edit ? 'back' : 'cancel') }}</v-btn>
      <v-btn v-if="editable" color="primary" class="btn-primary-custom" @click="submitForm" :loading="loading">{{
        $t(edit ? 'save' : 'submit')
      }}</v-btn>
    </div>

    <!-- Dialog Parent Create/Edit -->
    <v-dialog v-model="dialogParent" persistent width="80vw">
      <v-card>
        <v-card-title class="headline secondary white--text">{{ $t(parentDialogTitle) }}</v-card-title>
        <Form ref="formParentCreateEdit" type="parentCreateEdit" :initial-data="initialDataParent" />
        <div class="d-flex justify-end align-center pa-8 pt-0">
          <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="dialogParent = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" class="btn-primary-custom" :loading="loading" @click="submitParent">{{ $t('save') }}</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import SlideBox from '@/components/SlideBox';
import Form from '@/pages/parent/Form';
import StudentList from '@/pages/parent/index.vue';

export default {
  name: 'StudentCreateEdit',
  components: {
    BaseTitle,
    SlideBox,
    Form,
    StudentList
  },
  props: {
    editable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters({ user: 'Auth/user' }),
    isStudentPage() {
      return this.$route.name === 'AddStudent' || this.$route.name === 'EditStudent' || this.$route.name === 'ViewStudent';
    },
    isEditParentPage() {
      return this.$route.name === 'EditParent';
    },
    isViewParentPage() {
      return this.$route.name === 'ViewParent';
    },
    titleCreatePage() {
      if (this.edit && this.$route.name === 'ViewStudent') return 'content.student_view';
      if (this.edit && this.$route.name === 'EditStudent') return 'content.student_edit';
      if (this.edit) return 'content.parent_edit';
      if (this.isStudentPage && !this.edit) return 'content.student_create';
      return 'content.parent_create';
    },
    baseTitlePage() {
      return !this.editable && !this.isStudentPage ? 'content.parent_view' : this.titleCreatePage;
    },
    isCreatePage() {
      return this.$route.name === 'CreateParent' || this.$route.name === 'AddStudent';
    }
  },
  data: () => ({
    loading: false,
    edit: false,
    parentDialogTitle: '',
    initialDataStudent: null,
    initialDataParent: null,
    initialDateParentView: null,
    dialogParent: false,
    showParent: false,
    hideRemoveParent: false
  }),
  watch: {
    dialogParent(val) {
      if (!val) {
        document.querySelector('.v-dialog--active').scrollTop = 0;
      }
    }
  },
  methods: {
    getData() {
      // Load Student -> Parent
      this.$store.dispatch('User/fetchDetail', this.$route.params.userId ?? this.$route.params.id).then(student => {
        this.initialDateParentView = student;
        if (student.userParentId) {
          this.$store.dispatch('User/fetchDetail', student.userParentId).then(parent => {
            const studentCopyParent = {
              ...(this.$route.params.userId ? student : {}),
              phoneNumber: parent.phoneNumber,
              address: parent.address,
              provinceId: parent.provinceId,
              cityId: parent.cityId,
              postalCode: parent.postalCode,
              status: true
            };

            this.initialDataStudent = studentCopyParent;
          });
        }
      });
    },

    submitForm() {
      return !this.isStudentPage ? this.submitParent() : this.submit();
    },

    submit() {
      const student = this.$refs.formStudent;
      student.$v.$touch();
      if (student.$v.$invalid) return;

      this.loading = true;
      this.$store
        .dispatch(`Parent/${this.edit ? 'update' : 'save'}`, { ...student.getData(), parentId: this.$route.params.id })
        .then(() => {
          this.$router.push({ name: this.edit ? 'ParentEditStudentSuccess' : 'ParentAddStudentSuccess', params: { id: this.$route.params.id } });
        })
        .finally(() => (this.loading = false));
    },
    back() {
      let backuser = localStorage.getItem('backUser');
      if (backuser) {
        localStorage.removeItem('backUser');
        this.$router.push({ name: 'MasterUserSchool' });
      } else if (this.isStudentPage) {
        this.$router.go(-1);
        setTimeout(() => {
          window.location.reload();
          window.scrollTo(0, 0);
        }, 50);
      } else {
        this.$router.push({ name: 'ParentIndex' });
      }
    },
    addParent() {
      this.dialogParent = true;
    },
    submitParent() {
      const parent = this.$refs.formParent;
      const parentId = this.$refs.formParent.getParentId();
      parent.$v.$touch();
      if (parent.$v.$invalid) return;
      this.loading = true;
      this.$store
        .dispatch(`Parent/${parentId ? 'updateParent' : 'saveParent'}`, parent.getData())
        .then(({ data }) => {
          this.$set(this, 'initialDateParentView', data.data);
          parent.$v.$reset();
          this.dialogParent = false;

          if (parentId) this.$router.push({ name: 'ParentStudentEditSuccess', params: { id: this.$route.params.id } });

          if (!parentId) {
            this.$router.push({ name: 'EditParent', params: { id: data.data.userId } });
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        })
        .finally(() => (this.loading = false));
    },
    showFormParent() {
      this.showParent = true;
    },
    hideFormParent() {
      this.showParent = false;
    }
  },
  created() {
    if (this.$route.params.id && !this.isCreatePage) {
      this.edit = true;
      this.getData();
    }

    if (this.isStudentPage) {
      this.getData();
    }

    this.$root.$on('parentEdit', data => {
      this.dialogParent = true;
      const hasData = data?.userId;
      this.parentDialogTitle = hasData ? 'edit_parent' : 'add_new_parent';
      this.$set(this, 'initialDataParent', { ...data, ...(!hasData ? { status: true } : null) });
    });
  }
};
</script>

<style lang="scss" scoped>
.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}

.student {
  &-title {
    font-family: Montserrat;
    font-weight: bold;
    color: #6d6d6d;
    font-size: 18px;
  }

  &-content {
    margin-top: 20px;
    border-top: 1px solid #acacac;
    font-size: 12px;
  }
}
</style>
